/**
 * S2-4 (Final PRD §6–8) — read-only activation readiness, fetched from GET /agreements/{id}/activation-readiness.
 * It runs exactly the /activate gates server-side (no second rule set) and shows the first blocker, if any.
 */
import React, { useEffect, useState } from 'react';
import api from '@/lib/api';
import { Badge } from '@/components/ui/badge';
import { ShieldCheck, ShieldAlert } from 'lucide-react';

export function ActivationReadinessBadge({ agreementId, refreshKey }) {
  const [state, setState] = useState(null); // null | { ready, blocker, effective_status }

  useEffect(() => {
    if (!agreementId) return;
    let active = true;
    api.get(`/agreements/${agreementId}/activation-readiness`)
      .then((r) => { if (active) setState(r.data?.data || null); })
      .catch(() => { if (active) setState(null); });
    return () => { active = false; };
  }, [agreementId, refreshKey]);

  if (!state) return null;
  if (state.ready) {
    return (
      <Badge variant="outline" className="text-[10px] border-emerald-300 text-emerald-700" data-testid={`activation-ready-${agreementId}`}>
        <ShieldCheck className="h-3 w-3 mr-1" /> Ready to activate
      </Badge>
    );
  }
  const b = state.blocker || {};
  return (
    <Badge
      variant="outline"
      className="text-[10px] border-amber-300 text-amber-800 max-w-[18rem] truncate"
      title={b.message || b.code}
      data-testid={`activation-blocked-${agreementId}`}
    >
      <ShieldAlert className="h-3 w-3 mr-1 shrink-0" /> Not ready · {b.code || 'BLOCKED'}
    </Badge>
  );
}

export default ActivationReadinessBadge;
